import { Field } from 'redux-form';
import PhoneInput from './PhoneInput';

const PhoneField = (props) => {
  return (
    <div>
      <Field
        id={props.id}
        name={props.name}
        typeName={props.typeName}
        order={props.order}
        options={props.options}
        required={props.required}
        component={PhoneInput}
      />
    </div>);
}

export default PhoneField;